import { usePriceLatest } from './price/usePriceLatest';
import { useNativeToken } from './useNativeToken';

export const useNativeTokenPrice = () => {
  const nativeToken = useNativeToken();

  const nativeTokenPrice = usePriceLatest(nativeToken.symbol);

  return nativeTokenPrice;
};
